import { FC, useState } from "react";

import "./header.css";
import { useAuth0 } from "@auth0/auth0-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell } from "@fortawesome/free-regular-svg-icons";
import { MenuButton } from "../../button/MenuButton";
import { ProfileBalance } from "../../balance/Balance";
import AddLinkIcon from "@mui/icons-material/AddLink";
import PaymentLinkModal from "../../paymentLink/PaymentLinkModal";

const CustomHeader: FC = () => {
  const { user } = useAuth0();
  const [openPaymentLink, setOpenPaymentLink] = useState(false);

  const OnclickMenu = (event: any) => {};

  return (
    <>
      <header className="header">

        {/* <div className="notifications">
          
              <FontAwesomeIcon icon={ faBell} />
              <div className="alert"></div>
          </div>  */}
        <div className="balance-header">
          {" "}
          <ProfileBalance />
        </div>
        <button
          className="payment-link-header-btn"
          onClick={() => setOpenPaymentLink(true)}
        >
          <AddLinkIcon fontSize="small" />
          Crear link de pago
        </button>
        <div className="user">
          <MenuButton
            handleClick={OnclickMenu}
            name={user?.name}
            picture={user?.picture}
          />
        </div>
      </header>

      <PaymentLinkModal
        open={openPaymentLink}
        onClose={() => setOpenPaymentLink(false)}
      />
    </>
  );
};

export default CustomHeader;
